import React, { useState, useEffect } from 'react';
import { ButtonGroup, Button, Tabs, Tab } from '@mui/material';
import Home from '../../../components/Home/HomeBox'
import TimesheetsReport from '../../../components/Reports_V2/TimesheetsReport'
import CaseManagerCaseload from '../../../components/Reports_V2/CaseManagerCaseload';
import CaseInfo from '../../../components/CaseInfo/CaseInfo';
import WorkflowFormDialog from 'src/components/forms/WorkflowForm/WorkflowFormDialog';
import GridLayoutComponent from 'src/components/GridLayoutComponent/GridLayoutComponent';
import moment from 'moment';
import axios from 'axios'
import { APIURL } from '../../../config'

const CaseManagementEmployeeHome = (props) => {
    const [value, setValue] = useState('1');
    const [showWorkflow, setShowWorkflow] = useState(false);

    const isAdmin = props.user.type === 'Admin';
    const isSubscibedToTimeManagement = props.user.subs.find((setting) => setting.feature_id === 12) ? true : false;
    const isSubscibedToBIandReporting = props.user.subs.find((setting) => setting.feature_id === 16) ? true : false;

    useEffect(() => {
        const checkTokenExpiry = () => {
            props.checkTokenExpiry();
        };
        checkTokenExpiry();
    }, [props])

    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Tabs
                    indicatorColor="primary"
                    textColor="primary"
                    value={value}>
                    <Tab onClick={() => setValue('1')} label="Home" value="1" />
                    <Tab onClick={() => setValue('2')} label="Caseload Report" value="2" />
                    {isSubscibedToTimeManagement && <Tab onClick={() => setValue('3')} label="Timesheets Report" value="3" />}
                    {isAdmin && isSubscibedToBIandReporting && <Tab onClick={() => setValue('4')} label="Dashboard" value="4" />}
                </Tabs>
                <ButtonGroup size="small" sx={{ height: "40px", whiteSpace: "nowrap" }}>
                    {props.user.permissions.CreateNewWorkflow && <Button size="small" variant="contained" onClick={() => setShowWorkflow(true)}>NEW WORKFLOW</Button>}
                </ButtonGroup>
            </div>
            {value === '1' &&
                <div>
                    {isAdmin && <CaseInfo user={props.user} checkTokenExpiry={props.checkTokenExpiry} />}
                    <GridLayoutComponent
                        {...props}
                        checkTokenExpiry={props.checkTokenExpiry}
                        user={props.user}
                        comp_id={props.comp_id}
                    />
                </div>
            }
            {value === '2' &&
                <div>
                    <CaseManagerCaseload user={props.user} comp_id={props.comp_id} />
                </div>
            }
            {value === '3' &&
                <div style={{ width: '98%' }}>
                    <TimesheetsReport user={props.user} pagesize={20} comp_id={props.comp_id} />
                </div>
            }
            {value === '4' &&
                <div>
                    <Home {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} />
                </div>
            }
            <div>
                <WorkflowFormDialog {...props} open={showWorkflow} handleClose={() => setShowWorkflow(false)} />
            </div>
        </div>
    )
}

export default CaseManagementEmployeeHome;